import { StoreQueriesV2Mutation, StoreQueriesV2MutationVariables } from 'API';
import { API } from 'aws-amplify';
import { storeQueriesV2 } from 'graphql/mutations';

export const useStoreQueries = (): readonly [
  (storeQueriesVariables: StoreQueriesV2MutationVariables) => Promise<string | undefined | null>,
] => {
  const saveQueries = async (storeQueriesVariables: StoreQueriesV2MutationVariables) => {
    try {
      const response = (await API.graphql({
        query: storeQueriesV2,
        variables: storeQueriesVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: StoreQueriesV2Mutation };
      console.log('response', response.data.storeQueriesV2?.status);
      const responseStatus = response.data.storeQueriesV2?.status;
      return responseStatus;
    } catch (e) {
      console.log('ERROR SAVING CUSTOM REPORT KPI', e);
      return 'ERROR SAVING CUSTOM REPORT KPI';
    }
  };
  return [saveQueries];
};
